import { Verification } from "@usher/pe-client-front-end-lib"
import { FormattedMessage } from "react-intl"
import { Fragment } from "react/jsx-runtime"
import { getLink } from "../getLink"
import { VerificationStep } from "../VerificationStep"

interface Props {
  verify_flags: number
  type: string
}
export const PersonalSteps = ({ verify_flags, type }: Props) => {
  const isCardPage = type === "card"
  const isBankAccountType = type === "bank_account"
  return (
    <Fragment>
      <VerificationStep title="pa_161" active={verify_flags & Verification.VERIFICATION_EMAIL_EXCLIENT} />
      <VerificationStep title="pa_162" active={verify_flags & Verification.VERIFICATION_UTILITY_BILL_EXCLIENT} href={getLink(type)} />
      <VerificationStep title="pa_164" active={verify_flags & Verification.VERIFICATION_PASSPORT_EXCLIENT} href={getLink(type, "passport")}>
        <FormattedMessage id="ver-8" tagName="p" />
        <FormattedMessage id="ver-9" tagName="p" />
        <ul>
          <FormattedMessage id="ver-10_1" tagName="li" />
          <FormattedMessage id="ver-10" tagName="li" />
          <FormattedMessage id="ver-11" tagName="li" />
          <FormattedMessage id="ver-12" tagName="li" />
          <FormattedMessage id="ver-13" tagName="li" />
          <FormattedMessage id="ver-14" tagName="li" />
          <FormattedMessage id="ver-15" tagName="li" />
          <FormattedMessage id="ver-16" tagName="li" />
          <FormattedMessage id="ver-17" tagName="li" />
        </ul>
      </VerificationStep>
      <VerificationStep
        title="pa_166"
        active={verify_flags & Verification.VERIFICATION_UTILITY_BILL_EXCLIENT}
        href={getLink(type, "proof-of-address")}
      >
        <FormattedMessage id="pa_211_2" tagName="p" />
      </VerificationStep>
      {!isCardPage && (
        <>
          <VerificationStep title="pa_168" active={verify_flags & Verification.VERIFICATION_CARD_EXCLIENT} href={getLink(type, "proof-of-card")}>
            <FormattedMessage id="pa_211_3" tagName="p" />
          </VerificationStep>
          <VerificationStep
            title="pa_170"
            active={verify_flags & Verification.VERIFICATION_SELFIE_PASSPORT_EXCLIENT}
            href={getLink(type, "photo-with-passport")}
          >
            <FormattedMessage id="ver-7" tagName="p" />
          </VerificationStep>
          <VerificationStep title="pa_172" active={1} href={getLink(type, "set-your-wallet")} />
        </>
      )}
      {isBankAccountType ? <VerificationStep title="get_verification_link" href={getLink(type, "get-link")} active={1} /> : null}
      {isCardPage && (
        <>
          <VerificationStep
            title="pa_170"
            active={verify_flags & Verification.VERIFICATION_SELFIE_PASSPORT_EXCLIENT}
            href={getLink(type, "photo-with-passport")}
          >
            <FormattedMessage id="ver-7" tagName="p" />
          </VerificationStep>
        </>
      )}
    </Fragment>
  )
}
